import { render } from "./EntitlementUsageCard.vue?vue&type=template&id=311d5337&scoped=true"
import script from "./EntitlementUsageCard.vue?vue&type=script&lang=js"
export * from "./EntitlementUsageCard.vue?vue&type=script&lang=js"

import "./EntitlementUsageCard.vue?vue&type=style&index=0&id=311d5337&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311d5337"]])

export default __exports__